var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5002C4.86417 16.5002 1.5 13.1361 1.5 9.00024C1.5 4.86441 4.86417 1.50024 9 1.50024C13.1358 1.50024 16.5 4.86441 16.5 9.00024C16.5 13.1361 13.1358 16.5002 9 16.5002ZM12.7508 8.25025H9.75V5.24949H8.25V8.25025H5.25V9.75025H8.25V12.7502H9.75V9.75025H12.7508V8.25025Z",
    fill: "#009745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.99cb46d56907f01deb9d77cd57dd2776.svg";
export { ForwardRef as ReactComponent };